var styles = {"link":"Link-module_link__oMSAU","active":"Link-module_active__HMJAx","disabled":"Link-module_disabled__wWRPB","withIcon":"Link-module_withIcon__S7LTL","text":"Link-module_text__WEudl","pillPreset":"Link-module_pillPreset__U8JqP"};

export { styles as default };
//# sourceMappingURL=Link.module.scss.js.map
